import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
export function getPickerDayUtilityClass(slot) {
  return generateUtilityClass('MuiPickerDay', slot);
}
export const pickerDayClasses = generateUtilityClasses('MuiPickerDay', ['root', 'dayOutsideMonth', 'today', 'selected', 'disabled', 'fillerCell']);